import React from "react"

import { withHero } from "./withHero"
import { HeroContent } from "./Content/HeroContent"
import { StyledContainer } from "../../Styled/Container"
import { StyledImage } from "../../Styled/Image"
import { Section, Banner, Images, Content, Title } from "./HeroStyles"

export const Hero = withHero(
  ({ active, animated, handleSlide, heading, items }): JSX.Element => (
    <Section>
      <Banner>
        {items?.map(({ _key, image }, index: number) => (
          <Images key={_key} active={active === index || (active === false && !index)}>
            {image?.desktop && (
              <StyledImage alt={image?.desktop?.alt} fluid={image?.desktop} screen={`md>`} imgStyle={{ objectPosition: `top center` }} />
            )}
            {image?.mobile && <StyledImage alt={image?.mobile?.alt} fluid={image?.mobile} screen={`<sm`} />}
          </Images>
        ))}
        <StyledContainer width={`xl`}>
          <Content>{heading && <Title>{heading}</Title>}</Content>
        </StyledContainer>
      </Banner>
      <HeroContent active={active} animated={animated} handleSlide={handleSlide} items={items} />
    </Section>
  )
)

export default Hero
